import { injectable } from 'inversify-props'
import request from '@/common/request';
import { ImportacaoDeNotaServiceAdapter } from '@/usecases';
import { ImportacaoDeNota } from '@/models/ImportacaoDeNota';
import { PedidoDeVenda, Produto } from '@/models';

const PATH = '/importacoes-de-nota'

@injectable()
export class ImportacaoDeNotaService implements ImportacaoDeNotaServiceAdapter {
	async importar(arquivoNotaXml: File): Promise<ImportacaoDeNota> {
		return await request.post(`${PATH}/gerar`, arquivoNotaXml, { headers: { 'Content-Type': 'application/xml' } })
	}

	async finalizarImportacao(urlDoArquivoJson: string, naoDeveMovimentarEstoque: boolean, naoDeveAtualizarTabelaDePreco: boolean): Promise<ImportacaoDeNota> {
		return await request.post(`${PATH}/finalizar?urlDoArquivoCsv=${urlDoArquivoJson}&naoDeveMovimentarEstoque=${naoDeveMovimentarEstoque}&naoDeveAtualizarTabelaDePreco=${naoDeveAtualizarTabelaDePreco}`)
	}

	async vincularProduto(cEan: string, cProd: string): Promise<Produto[]> {
		return await request.post(`${PATH}/vincularProduto/${cEan}/${cProd}`)
	}

	async buscarProdutosParaRelacionar(identificadorDoProduto: string, tipoDoFiltro: string): Promise<Produto[]> {
		return await request.post(
			`${PATH}/buscaDeProdutosParaVincular/${tipoDoFiltro}`,
			{ identificadorDeProduto: identificadorDoProduto },
		);
	}

	async importarNotaFiscalParaPedido(arquivoNotaXml: File, pedidoId: string): Promise<PedidoDeVenda> {
		return await request.post(`${PATH}/pedido/${pedidoId}`, arquivoNotaXml, { headers: { 'Content-Type': 'application/xml' } })
	}
}
